export interface LabelValue {
  label: string;
  value: number;
}

// Combines slices smaller than 3% of the total into a single "Other" segment,
// while always keeping at least two named segments visible.
export function groupSmallSegments<T extends LabelValue>(data: T[]): LabelValue[] {
  const total = data.reduce((s, v) => s + v.value, 0);
  if (total === 0) return data;
  const main: LabelValue[] = [];
  const small: LabelValue[] = [];
  for (const d of data) {
    if (d.value / total < 0.03 && main.length + small.length < data.length - 2) {
      small.push({ label: d.label || 'Unknown', value: d.value });
    } else {
      main.push({ label: d.label || 'Unknown', value: d.value });
    }
  }
  if (small.length > 0) {
    main.push({ label: 'Other', value: small.reduce((s, v) => s + v.value, 0) });
  }
  return main;
}
